import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { useTypewriter } from 'views/rebranded-module/common/hooks/useTypewriter';
import { useIntersectionObserver } from 'views/rebranded-module/common/hooks/useIntersectionObserver';
import StyledBox from 'views/rebranded-module/information-module/AboutUsViewV2/components/BannerSection/BannerSection.styles';

const BannerSection: React.FC = () => {
  const content = useContent('AboutUsPage');
  const getSizedImage = useAdabtiveMultiSizeImage();
  const { ref, isIntersecting } = useIntersectionObserver({ threshold: 0.3 });
  const { displayText, isComplete, startTyping } = useTypewriter({
    text: content.bannerHeadingFirst,
    speed: 120,
  });

  useEffect(() => {
    if (isIntersecting) {
      startTyping();
    }
  }, [isIntersecting, startTyping]);

  return (
    <StyledBox ref={ref}>
      <Box className="BSOverlay" />
      <Box className="BSBackgroundImage">
        <ImgBox
          image={{
            src: getSizedImage(content.bannerBackgroundImage),
            alt: content.bannerBackgroundImage.alt,
          }}
          width="100%"
          height="100%"
          unoptimized
        />
      </Box>
      <Box className="BSContent">
        <Typography
          variant="h2"
          component="h2"
          className="BSFirstHeading"
          textTransform="uppercase">
          {displayText}
          {!isComplete && <span className="cursor blink">|</span>}
        </Typography>
        <Typography
          variant="h1"
          component="h2"
          className="BSSecondHeading"
          textTransform="uppercase">
          {content.bannerHeadingSecond}
        </Typography>
      </Box>
    </StyledBox>
  );
};

export { BannerSection };
